import styled, { css } from 'styled-components';
import _Icon from '../Icon';

export const Wrapper = styled.div(
  ({ theme }) => css`
    background-color: ${theme.co.neutral99};
    border-radius: 0 ${theme.sz.s6} 0 0;
    box-shadow: 0 ${theme.sz.s05} ${theme.sz.s1} 0 ${theme.co.neutral0}25;
    display: flex;
    gap: ${theme.sz.s1};
    align-items: center;
    justify-content: end;
    padding: ${theme.sz.s3} ${theme.sz.s6};
  `,
);

export const HeaderIcon = styled(_Icon)<{ $active?: boolean }>(
  ({ theme, $active }) => css`
    padding: ${theme.sz.s2};
    font-size: ${theme.sz.s8};
    color: ${theme.co.secondary0};

    ${$active &&
    css`
      border-radius: ${theme.bo.round};
      background-color: ${theme.co.primary20};
      outline: ${theme.bo.mediumWidth} solid ${theme.co.primary20};
      outline-offset: ${theme.bo.thickWidth};
      margin-left: ${theme.sz.s2};
      margin-right: ${theme.sz.s2};
    `}
  `,
);

export const ProfileIcon = styled(HeaderIcon)(
  ({ theme }) => css`
    font-size: ${theme.sz.s10};
    padding: ${theme.sz.s1};
    border-radius: ${theme.bo.round};
    background-color: ${theme.co.neutral98};
  `,
);
